export enum SolverMethod {
  Segregated = 0,
  AMG = 1,
  Parallel = 2,
  GCV = 3,
  ParallelGCV = 4,
  ParallelAMG = 5,
}
